import $ from 'jquery'
import _ from 'lodash'
import template from './annual-metric-data-form.hbs'
import EditReportsComponentDialog from '../common/edit-reports-component-dialog'
import AnnualMetricDataModel from 'scoreboard/reports/annual-metric-data/annual-metric-data-model'
import AnnualMetricDataOptionsView from 'scoreboard/reports/wizard/annual-metric-data/annual-metric-data-options'
import SelectScorecardView from '../wizard/common/select-scorecard-dialog'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import calendars from 'scoreboard/components/calendars'
import * as reportFormHelper from '../common/report-form-helper'
import BaseReportEditForm from '../common/base-report-form'
import config from 'scoreboard/components/config'

function optionLabels() {
	return {
		'showId': 'common.id',
		'showCalendar': 'report.metricsReport.column.frequency',
		'showOwners': 'report.twelvePeriodReport.form.owners',
		'showUpdaters': 'report.twelvePeriodReport.form.updaters',
		'showParents': 'scorecards.metrics.structure.short',
		'showSubMetrics': 'report.customReport.showSubMetrics.short',
		'showInitiatives': 'initiatives.initiatives',
		'showImpact': 'report.scorecardReport.column.influence',
		'showActual': 'scorecards.node.metric.actualValue',
		'showScore': 'common.score',
		'showGoal': 'scorecards.node.metric.threshold.goal',
		'showVariance': 'report.customReport.variance',
		'showVariancePercent': 'report.customReport.variancePercentage',
		'showTowardGoalPercent': 'report.customReport.percentOfGoal',
		'showTags': 'report.customReport.tags',
		'showYtd': 'report.scorecardReport.column.yearlyTotals',
		'showAbbreviatedValues': 'report.metricComparisonReport.showingAbbreviatedValues'
	}
}

var displayOptionsAttributes = ['annualCalendarPeriodId', 'breakdownCalendarId','displayOptions']

var EditAnnualMetricDataView = BaseReportEditForm.extend({

	className: 'table-hack-row display-pane-body',

	events: {
		'click .edit-scorecard': 'editScorecard',
		'click .edit-display-options': 'editDisplayOptions'
	},

	initialize: function(options) {
		this.options = options
		this.on('change', function() {
			this.model.set('label', this.label.val())
		}.bind(this))

		var rerenderChangedAttributes = ['scorecardItem'].concat(displayOptionsAttributes)
		reportFormHelper.listenToChanges(this, rerenderChangedAttributes)
	},

	render: function() {
		var options = this.model.get('displayOptions')

		// #13004 hide score column option if scores should not be visible
		if (!config.scoresVisible) {
			options.showScore = false
		}

		var selectedOptions = _.transform(optionLabels(), function(r,v,k) {
			options[k] ? r.push(v) : null
		}, [])

		var ctx = {
			label: this.model.get('label'),
			period: calendars.periodsById[this.model.get('annualCalendarPeriodId')],
			calendar: calendars.calendarsById[this.model.get('breakdownCalendarId')],
			displayOptions: selectedOptions,
			scorecardItem: this.model.get('scorecardItem')
		}
		var content = $(template(ctx))
		this.$el.html(content)
		this._initLabelField()

		this.$('.report-info')
			.toggleClass('is-not-displayed', !!this.options.embedded)

		return this
	},

	editScorecard: function() {
		var id = this.model.get('scorecardItem') ? this.model.get('scorecardItem').id : null
		var selectScorecard = new SelectScorecardView({
			data: { id: id },
			hideFollowLinked: true
		})
		selectScorecard.on('done', function() {
			this.model.set('scorecardItem', selectScorecard.data.item)
		}.bind(this))
		appDisplay.dialog(selectScorecard)
	},

	editDisplayOptions: function() {
		var model = new AnnualMetricDataModel(_.defaults({
			displayOptions: _.clone(this.model.get('displayOptions'))
		}, this.model.attributes))
		var view = new EditReportsComponentDialog({
			view: AnnualMetricDataOptionsView,
			model: model,
			header: i18n.get('report.twelvePeriodReport.title')
		})
		view.on('done', function() {
			_.map(displayOptionsAttributes, function(v) {
				this.model.set(v, model.get(v))
			}.bind (this))
		}.bind(this))
		appDisplay.dialog(view)
	}

})

export default EditAnnualMetricDataView

EditAnnualMetricDataView.__filename__ = 'reports/annual-metric-data/annual-metric-data-form.js'
